import { Services } from '@sigma-frontend-libs/commons'

import { moderationColors, moderationIcons } from '@/utils'

import { statusColors, statusIcons } from '@/components/services/sendingsModeration/utils'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderStatus(h) {
  if (this.value.status) {
    let statusValue
    let statusLabel
    if (!this.viewport.breakpoint.xs) {
      statusValue = this.getTranslate(`${Services.sendingsModeration}.labels.tasks.status.${this.value.status}`)
      statusLabel = this.getTranslate(`${Services.sendingsModeration}.labels.status`)
    }

    return h(
      sticker,
      {
        props: {
          value: statusValue,
          label: statusLabel,
          icon: statusIcons[this.value.status],
          color: statusColors[this.value.status],
          iconTooltip: this.getTranslate(`${Services.sendingsModeration}.tooltips.tasks.status.${this.value.status}`)
        }
      }
    )
  }
}

function renderModeration(h) {
  if (this.value.moderation) {
    let moderationValue
    let moderationLabel
    if (!this.viewport.breakpoint.xs) {
      moderationValue = this.getTranslate(`${Services.sendingsModeration}.labels.tasks.moderation.${this.value.moderation}`)
      moderationLabel = this.getTranslate(`${Services.sendingsModeration}.labels.moderation`)
    }

    return h(
      sticker,
      {
        props: {
          value: moderationValue,
          label: moderationLabel,
          icon: moderationIcons[this.value.moderation],
          color: moderationColors[this.value.moderation],
          iconTooltip: this.getTranslate(`${Services.sendingsModeration}.tooltips.tasks.moderation.${this.value.moderation}`)
        }
      }
    )
  }
}

function renderSender(h) {
  if (this.viewport.breakpoint.lgUp) {
    if (this.value.sender) {
      return h(
        sticker,
        {
          props: {
            value: this.value.sender,
            label: this.getTranslate(`${Services.sendingsModeration}.labels.sender`)
          }
        }
      )
    }
  }
}

function renderPattern(h) {
  if (this.value.pattern) {
    return h(
      sticker,
      {
        props: {
          value: this.value.pattern,
          label: this.getTranslate(`${Services.sendingsModeration}.labels.text`)
        }
      }
    )
  }
}

function renderProvider(h) {
  if (this.viewport.breakpoint.mdUp) {
    if (this.value.providerId) {
      return h(
        sticker,
        {
          props: {
            value: this.value.providerId,
            label: this.getTranslate(`${Services.sendingsModeration}.labels.providerId`),
            service: Services.providers,
            pathToTitle: 'title'
          }
        }
      )
    } else {
      return h(
        sticker,
        {
          props: {
            value: this.getTranslate(`${Services.sendingsModeration}.hints.provider`),
            label: this.getTranslate(`${Services.sendingsModeration}.labels.providerId`)
          }
        }
      )
    }
  }
}

function renderDetails(h) {
  return h(
    'div',
    {
      class: `${Services.sendingsModeration}-task__info`
    },
    [
      renderStatus.call(this, h),
      renderModeration.call(this, h),
      renderSender.call(this, h),
      renderProvider.call(this, h),
      renderPattern.call(this, h)
    ]
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `service-template-item ${Services.sendingsModeration}-task`,
      on: {
        click: () => {
          this.$emit('click')
        }
      }
    },
    [
      renderDetails.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
